<div id="workflowWidgetContainer" *ngIf="showWorkflowWidget"></div>
<div [innerHtml]="routingHistoryString" *ngIf="showRoutingHistory"></div>